<template>
  <div class="content">   
<el-dialog :visible.sync="tachesVisible" style="width:110%;" @close='handleCloseReload' > 
       <fieldset style="width:100%">         
                    <legend> Les tâches de l'action N° {{numAct}} : {{objet}}</legend>   
                    
                    <el-table class="" style="height:40vh;"
                        :data="listeTaches"
                        :default-sort = "{prop: 'date', order: 'descending'}"
                        max-height="250" 
                        @row-click='rowClikedListeTache'
                      >
                        <el-table-column
                            prop="RANG"
                            label="Numéro"
                            width="70">
                        </el-table-column>
                      
                        <el-table-column
                            prop="RESSOURCE"
                            label="Intervenant"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="TACHE2"
                            label="Tâche(s)"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="DTE_PREV2"
                            label="Prévu(e) le"
                            width="90">
                        </el-table-column>
                        <el-table-column
                            prop="DTE_REAL2"
                            label="Realisé(e) le"
                            width="90">
                        </el-table-column>
                        <el-table-column
                           v-if="etat=='En cours'"
                            label="Opérations"
                            width="87">
                            <template slot-scope="scope">
                                
                                <el-button
                                slot="reference"
                                size="mini "
                                circle
                                    @click.native.prevent="handleSupprimerTache(scope.row.RANG)"
                                    class="circleButtons"
                                    icon="el-icon-delete">
                                   
                                </el-button>
                            </template>
                        </el-table-column> 
                    </el-table>
                    <br>
                 
                    <el-row style="margin-top:15px">

                        
                        <el-col class="ColonneGauche" :span="17"  >
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span style="font-size:14px">Realisé(e) le  :</span>
                            <el-date-picker size='mini' class="dateAction selectColDroite" type="date"
                                id='dialogDate_real' v-model='dialogTache.date_real'
                                placeholder="Date et heure" name='date_real' value-format="yyyy-dd-MM"
                                format="yyyy-dd-MM" >
                            </el-date-picker>
                            &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;

                            <el-button   size="mini" style="margin-left: 10px;"
                            v-if="etat=='En cours'"
                            round 
                            @click="AfficherCreationTache" > 
                            Ajouter
                            </el-button>

                            <el-button style="margin-left: 10px;"
                            @click="newDateRealiz()"   size="mini" v-if="etat=='En cours'"
                            round>
                            Clôturer
                        </el-button>

                        <el-button style="margin-left: 10px;"
                            onclick="history.go(0)"   size="mini" 
                            round>
                            Retour
                        </el-button>

                        

                        </el-col>
                    </el-row>
                    <div>
                        <el-row style="margin-top:5px;">
                            <el-col  style=" margin-bottom:10px;font-weight:bold ;font-size:16px;text-align: left;margin-left: 10px;" >
                                Observations :
                            </el-col>
                            <el-col :span="24" class="ColDroiteInterlocuteur">
                                <el-input style= "max-height: 100px; " type="textarea" placeholder="Veuillez saisir"
                                    v-model="texteObs" rows=14  
                                    class="TextareaFont" @blur='handleTextareaTache(1,1)'>
                                </el-input>
                            </el-col>
                        </el-row>
                    </div>                 
                        <el-dialog title="Ajout d'une tâche" :visible.sync="dialogFormTacheVisible" style="width:68.5%;margin-left:21%;margin-top:0px;"
                            @close='handleClose' 
                            @opened='tester123'
                            class="dialogAjout">
                            <form class="" style="height:480px;" method="post" id='formAjoutTache'>
                                <el-row>
                                    <el-col :span="4" class="ColonneGauche">
                                        Intervenant :
                                    </el-col>
                                    <el-col :span="9" class="ColDroiteDialogTache ">
                                        <el-select placeholder="Veuillez séléctionner un intervenant" v-model='dialogTache.intervenant'
                                            id='dialogIntervenant' size='mini' name='intervenant'>

                                            <el-option v-for="item in listeIntervenants" :key="item.USER_NAME"
                                                :label="item.USER_NAME" :value="item.USER_NAME">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:15px;">
                                    <el-col class="ColonneGauche" :span="4">
                                        Tâche :
                                    </el-col>
                                <el-col :span="9" class="ColDroiteDialogTache ">
                                  <!--
                                    <el-select placeholder="Veuillez séléctionner une tâche" v-model='dialogTache.tache'
                                            id='dialogTache' size='mini' name='tache'
                                             allow-create>
                                            <el-option  :label='null' :value='null'></el-option>
                                            <el-option v-for="item in listetache" 
                                            :key="item.TACHE"
                                            :label="item.TACHE" 
                                            :value="item.TACHE">
                                            </el-option>
                                        </el-select>-->
                                  <input id="dialogTache" type="text" v-model='dialogTache.tache' list="listetache">
                                  <datalist id="listetache">
                                    <option v-for="item in listetache">{{item.TACHE}}</option>
                                  </datalist>

                                 </el-col>

                                </el-row>
                                <el-row style="margin-top:15px">
                                    <el-col class="ColonneGauche" :span="4">
                                        <span>
                                        Prévue le :
                                        </span>
                                    </el-col>
                                    <el-col :span="17" style="text-align:left">
                                        <el-date-picker size='mini' class="dateAction selectColDroite" type="datetime"
                                            id='dialogDate_prev' v-model='dialogTache.date_prev'
                                            placeholder="Date et heure" name='date_prev' value-format="yyyy-MM-dd HH:mm"
                                            format="dd-MM-yyyy HH:mm">
                                        </el-date-picker>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:15px">
                                    <el-col class="ColonneGauche" :span="4">
                                        <span>
                                        Réalisée le :
                                        </span>
                                    </el-col>
                                    <el-col :span="17" style="text-align:left">
                                        <el-date-picker size='mini' class="dateAction selectColDroite" type="date"
                                            id='dialogDate_real' v-model='dialogTache.date_real'
                                            placeholder="Date et heure" name='date_real' value-format="yyyy-MM-dd"
                                            format="dd-MM-yyyy">
                                        </el-date-picker>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:15px;">
                                    <el-col :span="4" class="ColonneGauche">
                                        Observations :
                                    </el-col>
                                    <el-col :span="17" class="ColDroiteDialogTache">
                                        <el-input type="textarea" placeholder="Veuillez saisir" rows=4
                                            v-model='dialogTache.observation' id='dialogObservation'
                                            class="TextareaFont" name='observation' resize='none'>
                                        </el-input>
                                    </el-col>
                                </el-row>
                                <div class="dialog-footer">
                                  <el-button type="primary" @click="handleEnregistrementTache" size='mini'>Enregistrer
                                    </el-button>
                                    <el-button @click="dialogFormTacheVisible = false" size='mini'>Retour</el-button>
                                    
                                </div>
                            </form>
                        </el-dialog>
  </fieldset>


  </el-dialog>


    <el-dialog title="Ajout d'une action" :visible.sync="dialogFormActionVisible" style="width:90%;" class="dialogAjout">
    
      <form class="" action="action.php" method="post" id='formAjoutAction'>
        <el-row style="margin-top:15px">
          <el-col :span="4" class="ColonneGauche"> Client *: </el-col>
          <el-col :span="9" class="ColDroiteDialogTache ">
            <el-select placeholder="Veuillez saisir un client" v-model='dialogAction.client' id='selectClient' size='mini' name='client' filterable>
              <el-option :key='null' :label='null' :value='null' ></el-option>
               <el-option
                v-for="item in optionsNom_Cli"
                :key="item.CDE_CLI"
                :label="item.NOM_CLI"
                :value="item.CDE_CLI">
              </el-option>
            </el-select>
          </el-col>
        </el-row> 
        <br />
        <el-row style="margin-top:15px">
          <el-col :span="4" class="ColonneGauche"> Objet * : </el-col>
          <el-col :span="9" class="ColDroiteDialogTache ">
            <el-input placeholder="Veuillez saisir un objet" v-model='dialogAction.objet' id='selectObjet' size='mini' name='objet' >
              <el-option :key='null' :label='null' :value='null' ></el-option>
               
            </el-input>
          </el-col>
        </el-row>
        <br />
        
        <el-row style="margin-top:15px">
          <el-col :span="4" class="ColonneGauche"> Priorité *: </el-col>
          <el-col :span= "9" class="ColDroiteDialogTache ">
            <el-select placeholder="Veuillez saisir une priorité" v-model='dialogAction.priorite' id='selectPriorite' size='mini' name='priorite' filterable>
              <el-option :key='null' :label='null' :value='null' ></el-option>
               <el-option
                v-for="item in optionsPriorite"
                :key="item.CDE_TABLE"
                :label="item.LIB_50"
                :value="item.CDE_TABLE">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
         <br/>
        <el-row style="margin-top:15px;">
          <el-col :span="4" class="ColonneGauche">
            <span>
              Crée le * : 
            </span>
          </el-col>
          <el-col  :span="4"  style="text-align:left">
            <el-date-picker
              size='mini'
              class="dateAction selectColDroite"
              type="date"
              placeholder="Date"
              id='dialogDate_creat'
              v-model='dialogAction.date_creat'
              format="dd-MM-yyyy">
            </el-date-picker>
          </el-col>
        </el-row>
        <br />
        <el-row style="margin-top:15px;"  >
          <el-col :span="4" class="ColonneGauche">
            <span>
              Début le *: 
            </span>          
          </el-col>
          <el-col :span="4" style="text-align:left">
            <el-date-picker
              size='mini'
              class="dateAction selectColDroite"
              type="datetime"
              placeholder="Date et heure"
              id='dialogDate_prev'
              v-model='dialogAction.date_prev'
              name='date_prev'
              format="dd-MM-yyyy HH:mm"
              >
              </el-date-picker>
          </el-col>
        </el-row>
      
        <br />
        
        <el-row style="margin-top:15px">
          <el-col :span="4" class="ColonneGauche">
            <span>
              Fin le *: 
            </span>          
          </el-col>
          <el-col :span="4" style="text-align:left">
            <el-date-picker
              size='mini'
              class="dateAction selectColDroite"
              type="datetime"
              placeholder="Date et heure"
              id='dialogDate_fin'
              v-model='dialogAction.date_fin'
              name='date_fin'
              format="dd-MM-yyyy HH:mm"
              >
              </el-date-picker>
          </el-col>
        </el-row>
        <br />
       
        <div  class="dialog-footer">
          <el-button @click="handleRetour()"  size='mini'>Retour</el-button>
          <!-- enregistrement action -->
          <el-button type="primary" @click="handleEnregistrementAction" size='mini'>Enregistrer</el-button>
        </div>
      </form>

    </el-dialog>
      
<!-- "handleFiltrer" -->

  
    <!-- -------------------------------------------------------------------------------------------------------------- -->
           <el-row>
           <el-col :span="3" class="text-left" style="width:100%; background: rgb(240, 240, 240);">
            <div style="top:29px;left:10px;z-index: 20;" >
             <el-badge style="top:3px;width:50px;" v-model="count_table" class="item"></el-badge>
             <el-button style="left:30px;height:35px;width:120px;line-height:4px;background-color: rgb(108, 117, 125) !important; color: white !important;"  @click="show3 = !show3" align="right" >Filtrer(s)</el-button>
            <el-input style="top:-1px;left:20px;z-index: 20;width:170px"
              v-model="search"
              size="mini"
              placeholder="Rechercher"/>
            <label for="cloturee" style="margin-left:50px;font-weight : bold;"> Inclure l’historique :</label>
            <el-switch style="margin-left:10px;"
                    name='cloturee'
                    v-model="is_history"
                    >
            </el-switch>
            </div>
          </el-col>
          <el-col :span="5">    
          </el-col>
          </el-row>
       
  
     <el-collapse-transition>
          <div v-show="show3">
              <el-card class="box-card BoxDetailFiltre2">
                   <el-form ref="form" label-width="120px" size="mini" style="margin-top:-10px" center>
           
                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px ;;margin-top:5px;">
                                              <span>
                                              Commercial
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select v-model="dialogActionFiltre.VENDEUR" style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" 
                                                  placeholder="Veuillez sélectionner un commercial" class="selectColDroite2" id='selectCommercial'  name='commercial' filterable>
                                                  <el-option align="left"
                                                    v-for="item in listeCommercial"
                                                    :key="item.VENDEUR"
                                                    :label="item.VENDEUR"
                                                    :value="item.VENDEUR">
                                                  </el-option>
                                                 
                                              </el-select>
                                          </el-col>
                              </el-row>

                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                          Auteur
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select v-model='dialogActionFiltre.AUTEUR' id='selectClient' style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" placeholder="Veuillez sélectionner un auteur" 
                                              filterable class="selectColDroite2">
                                                        <el-option align="left"
                                                          v-for="item in listeAuteur"
                                                          :key="item.AUTEUR"
                                                          :label="item.AUTEUR"
                                                          :value="item.AUTEUR">
                                                        </el-option>
                                              </el-select>
                                          </el-col>
                              </el-row>

                               <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                        Etat de l'action
                                              </span>
                                          </el-col>
                                          <el-col :span="2">
                                              <el-select v-model="dialogActionFiltre.ETAT"  style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" placeholder="Veuillez sélectionner une action en cours" class="selectColDroite2">
                                                   <el-option align="left"
                                                    v-for="item in listeEtat"
                                                    :selected="'En cours'"
                                                    :key="item.CDE_TABLE"
                                                    :label="item.ETAT"
                                                    :value="item.ETAT">
                                                  </el-option>
                                              </el-select>
                                          </el-col>
                              </el-row>

                           
                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                                 Objet de l'action
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select v-model='dialogActionFiltre.OBJET' style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" placeholder="Veuillez sélectionner un objet" class="selectColDroite2">
                                              <el-option align="left"
                                                    v-for="item in listeObjet"
                                                    :key="item.CDE_TABLE"
                                                    :label="item.LIB_50"
                                                    :value="item.LIB_50">
                                                  </el-option>
                                              </el-select>
                                          </el-col>
                              </el-row>
                      
                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                          Num Affaire
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select v-model='dialogActionFiltre.NUM_AFFAIRE' id='selectClient' style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" placeholder="Veuillez sélectionner une affaire" 
                                              filterable class="selectColDroite2">
                                                        <el-option align="left"
                                                          v-for="item in listeAffaire"
                                                          :key="item.NUM_AFFAIRE"
                                                          :label="item.NUM_AFFAIRE"
                                                          :value="item.NUM_AFFAIRE">
                                                        </el-option>
                                              </el-select>
                                          </el-col>
                              </el-row>
                              
                            <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                          Client
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select v-model='dialogActionFiltre.CDE_CLI' id='selectClient' style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" placeholder="Veuillez sélectionner un client" 
                                              filterable class="selectColDroite2">
                                                        <el-option align="left"
                                                          v-for="item in optionsNom_Cli"
                                                          :key="item.CDE_CLI"
                                                          :label="item.LABEL"
                                                          :value="item.CDE_CLI">
                                                        </el-option>
                                              </el-select>
                                          </el-col>
                              </el-row>

                               


                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                          Secteur
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select  v-model='dialogActionFiltre.SECTEUR_COMMERCIAL' style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" placeholder="Veuillez sélectionner un secteur" class="selectColDroite2" filterable>
                                                      <el-option align="left"
                                                          v-for="item in listeSecteur"
                                                          :key="item.SECTEUR_COMMERCIAL"
                                                          :label="item.SECTEUR_COMMERCIAL"
                                                          :value="item.SECTEUR_COMMERCIAL">
                                                        </el-option>
                                              </el-select>
                                          </el-col>
                              </el-row>

                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                          Technicien
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select v-model='dialogActionFiltre.TECHNICIEN' id='selectClient' style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" placeholder="Veuillez sélectionner un technicien" 
                                              filterable class="selectColDroite2">
                                                        <el-option align="left"
                                                          v-for="item in listeTechniciens"
                                                          :key="item.RES_LIB"
                                                          :label="item.RES_LIB"
                                                          :value="item.RESSOURC">
                                                        </el-option>
                                              </el-select>
                                          </el-col>
                              </el-row>

                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px;margin-top:5px">
                                              <span>
                                          Prestataire
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-select v-model='dialogActionFiltre.PRESTATAIRE' id='selectClient' style="margin-left:0px;margin-top:-5px;width:300px;color: black !important;" placeholder="Veuillez sélectionner un prestataire" 
                                              filterable class="selectColDroite2">
                                                        <el-option align="left"
                                                          v-for="item in listePrestataires"
                                                          :key="item.RES_LIB"
                                                          :label="item.RES_LIB"
                                                          :value="item.RESSOURC">
                                                        </el-option>
                                              </el-select>
                                          </el-col>
                              </el-row>
                              
                              <el-row class="ligneActFiltre"  style="text-align:left;margin-left:10px ;">
                                  <el-radio-group v-model="radio">
                                    <el-radio :label="9">Crée le</el-radio>
                                    <el-radio  :label="3">Prévue le </el-radio>
                                    <el-radio :label="6" >Réalisé  le </el-radio>
                                  </el-radio-group>
                                 </el-row>
                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px ;margin-top:5px">
                                              <span>
                                              Date Début
                                              </span>
                                          </el-col>
                                          <el-col :span="3">
                                              <el-date-picker size='mini'    v-model='dialogActionFiltre.DTE_PREV' id='detail_dte_prev' style="margin-left:0px ;margin-top:-5px;width:300px"
                                                  class="selectColDroite" type="datetime" placeholder="Date et heure"
                                                  value-format="dd-MM-yyyy" format="dd-MM-yyyy" 
                                                  >
                                              </el-date-picker>
                                          </el-col>
                              </el-row>
                              <el-row class="ligneActFiltre">
                                          <el-col class="ColonneGauche" :span="2" style="margin-left:10px ;margin-top:5px">
                                              <span>
                                              Date Fin
                                              </span>
                                          </el-col>
                                          <el-col :span="2">
                                              <el-date-picker size='mini'  v-model='dialogActionFiltre.DTE_REAL' id='detail_dte_real' style="margin-left:0px ;margin-top:-5px;width:300px"
                                                  class="selectColDroite" type="datetime" placeholder="Date et heure"
                                                  value-format="dd-MM-yyyy" format="dd-MM-yyyy" 
                                                  >
                                              </el-date-picker>
                                          </el-col>
                                </el-row>
                  
                                <el-row class="ligneActFiltre">
                                  <el-col class="ColonneGauche" :span="3" style="margin-left:200px">
                                  <el-button
                                      type="primary"
                                      style="margin-left:185px"
                                      size="small "
                                      id="delete_filtre"
                                      icon="el-icon-check"
                                      @click="handle_delete_filtre"
                                      >Effacer les filtres
                                </el-button>
                                  </el-col>

                                    
                              </el-row>
                   </el-form>
              </el-card>
        </div>
    </el-collapse-transition>




    <!-- ----------------------------------------------------------------------------------------------------------------- -->
      <div class="table-container">
        
        <el-table 
        v-if='showTableRefresh'
         :data="tableDataComputed" :cell-class-name="tableCellClassName" 
         
          style="width: 100%;margin-top:0px;"
          height=90%
          
          class="tableCenter"
          
          empty-text="Aucun ">
        
          <el-table-column
            align="left"
            fixed="left"
            v-model="search"
            prefix-icon="custom-icon el-icon-search"
            label="" 
            width=150px;
            >
            
          <template slot-scope="scope">

            <el-popover 
            placement="top-start"
            width="70"
            trigger="hover"
            content="Voir l'action"
            popper-class="popperBtn">
              <el-button
                 slot="reference"
                 size="mini "
                 circle
                  type="danger"
                 @click='handleBtnDetail(scope.row)'
                 class="circleButtons"
                 icon="el-icon-document">
               </el-button>
             </el-popover>

             <el-popover
              placement="top-start"
              width="70"
              trigger="hover"
              content="Localiser l'action"
              style="margin-left:5px"
              popper-class="popperBtn">
                <el-button 
                  slot="reference"
                  icon="el-icon-location-outline"
                  class="circleButtons"
                  @click="handleLocation(scope.$index, scope.row)"
                  size="mini"
                   type="danger"
                  circle>                                              
                </el-button>
              </el-popover>

              <el-popover
              placement="top-start"
              width="70"
              trigger="hover"
              content="Voir les Tâches"
              style="margin-left:5px"
              popper-class="popperBtn">
                <el-button 
                  slot="reference"
                  icon="el-icon-menu"
                  v-if="scope.row.nbr_task>=1"
                  type="danger"
                  class="circleButtons"
                  @click="handletaches(scope.$index, scope.row)"
                  size="mini"
                  circle>                                              
                </el-button>

                <el-button 
                  slot="reference"
                  icon="el-icon-menu"
                  class="circleButtons"
                  v-else
                  @click="handletaches(scope.$index, scope.row)"
                  size="mini"
                  circle>                                              
                </el-button>
              </el-popover>

            </template>
         </el-table-column>

            <!-- VUE DE SUIVI DES ACTIONS -->

         <el-table-column
           prop="VENDEUR"
           label="Commercial"
           width="120"
           text-align= "center"
           sortable>
         </el-table-column>

          <el-table-column
           prop="AUTEUR"
           label="Auteur"
           width="110"
           text-align= "center"
           sortable>
         </el-table-column>
         
         <el-table-column
           prop="NOM_CLI"
           label="Nom client"
           min-width="200"
           sortable>
         </el-table-column>        

        

         <el-table-column
           prop="NUM_ACTION"
           label="Action"
           width="90"
           sortable>
           <template slot-scope="scope">            
            <span :style="{ color: isActionLate(scope.row.DTE_PREV) && scope.row.ETAT !== 'Cloturé' ? 'red' : 'initial' }">{{ scope.row.NUM_ACTION }}</span>
          </template>
         </el-table-column>
         <el-table-column
           prop="OBJET"
           label="Objet"
           min-width="140"
           sortable>
         </el-table-column>

         <el-table-column
           prop="PRIORITE"
           label="Priorité"
           width="115"
           sortable>
         </el-table-column>

          <el-table-column
           prop="DTE_CREAT"
           label="Crée le"
           width="100"
           sortable>
         </el-table-column>

          <el-table-column
           prop="DTE_PREV"
           label="Prévue le"
           width="105"
           sortable>
         </el-table-column>
         <el-table-column
           prop="DTE_REAL"
           label="Réalisée le"
           width="115"
           sortable>
         </el-table-column>
         <el-table-column
           prop="ETAT"
           label="Etat"
           width="80"
           sortable>
         </el-table-column> 

         <el-table-column
           prop="NUM_AFFAIRE"
           label="N° affaire"
           min-width="110"
           sortable>
         </el-table-column>

         <el-table-column
           prop="NUM_DEV"
           label="Devis"
           width="90"
           sortable>
         </el-table-column>

         <el-table-column
           prop="QUANTITE"
           label="Quantité"
           width="105"
           sortable>
         </el-table-column>

        <el-table-column
           prop="MONTANT"
           label="CA Estimé"
           width="110"
           sortable>
         </el-table-column>

         <el-table-column
           prop="DTE_CONF"
           label="Remis le"
           width="100"
           sortable>
         </el-table-column>

         <el-table-column
           prop="RESSOURCE"
           label="Technicien"
           min-width="115"
           sortable>
         </el-table-column>

         <el-table-column
           prop="PRESTATAIRE"
           label="Prestataire"
           min-width="140"
           sortable>
         </el-table-column>
         
        <el-table-column
           prop="VILLE"
           label="Ville"
           width="200"
           sortable>
         </el-table-column>



       </el-table>
       <div class="block">
    
    <el-pagination
       @size-change="handleSizeChangePagination"
      @current-change="handleCurrentChangePagination"
      :page-size="table_size"
      layout="sizes,prev, pager, next, jumper"
      :total="count_table">
    </el-pagination>
  </div>
      </div>
      
    </div>    
  
</template>

<script>



  import axios from 'axios';
  import $ from 'jquery'; 
  import {BACKEND_URL} from './GLOBALS'
import Vue from 'vue'
 
const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
    moment
}) 
  
  export default {
    components: {
    },
    data () {
      return {
        dialogTache: {
                intervenant: '',
                tache: '',
                date_prev: new Date(),
                date_real: '',
                observation: '',
            },
        dialogFormTacheVisible:false,
        select:'',
        numAct:'',
        objet:'',
        insertH:0,
        etat:'',
        texteObs:'',
       RANGCourant:'',
        listeTaches:[],
        listetache:[],
        tachesVisible:false,
        selected:'En cours',
        table_index:0,
        table_size:100,
        radio:'3',
         count_table:0,
        showTableRefresh:true,
         show3: false,
         filtrage:'',
         actives:true,
        tableData: {},
      search:'',
      is_history: false,
      nom_com:'',
      dialogFormActionVisible:false,
      Retour:false,
      dialogAction :{
        cde_cli: '',  
        client: '',
        commercial:'',
        objet: '',
        etat:'',
        priorite: '0',
        date_creat: new Date(),
        date_real: '',
        date_prev: new Date(),
        dte_prev:'',
        dte_real:'',
        date_fin: '',
       
      },
      dialogActionFiltre :{

        VENDEUR:'',
        AUTEUR:'',
        ETAT:'',
        OBJET:'',
        CDE_CLI :'',
        SECTEUR_COMMERCIAL:'',
        DTE_PREV: new Date(),
        DTE_REAL: new Date(),
        NUM_AFFAIRE: '',
        TECHNICIEN: '',
        PRESTATAIRE: ''
      },
      optionsNom_Cli:{},
      listeAffaire:{},
      listeAuteur:{},
      listeTechniciens:{},
      listePrestataires:{},
      optionsPriorite:{} ,
      optionsObjet: {},
      listeActions:{},
      listeCommercial:{},
      listeEtat:{},
      listeObjet:{},
      listeSecteur:{},
      secteur:'',
      listeIntervenants:{}
     
      }
    },
    watch: {
      
    },
    computed: {
                  // a computed getter
                    tableDataComputed: function () {
                      // `this` points to the vm instance
                   
                      var resultSearch= this.tableData.map(element=> {
                            const temp_presta = this.listePrestataires.filter(data => data.RESSOURC==element.PRESTATAIRE)[0]
                            return {
                              ASSISTANT:element.ASSISTANT == null?'' :element.ASSISTANT  ,
                              VENDEUR:element.VENDEUR == null?'' :element.VENDEUR  ,
                              AUTEUR:element.CDE_PROFIL == null?'' :element.CDE_PROFIL  ,
                              ORIGINE:element.ORIGINE == null?'' :element.ORIGINE  ,
                              PRIORITE:element.PRIORITE == null?'' :element.PRIORITE  ,
                              CDE_CLI:element.CDE_CLI == null?'' :element.CDE_CLI  ,   
                              NOM_CLI:element.NOM_CLI == null?'' :element.NOM_CLI  ,
                              NUM_ACTION:element.NUM_ACTION == null?'' :element.NUM_ACTION  ,
                              OBJET:element.OBJET == null?'' :element.OBJET  ,
                              DTE_CREAT:element.DTE_CREAT== null?'':element.DTE_CREAT,
                              DTE_PREV:element.DTE_PREV == null?'' :element.DTE_PREV  ,
                              DTE_REAL : element.DTE_REAL == null?'' :element.DTE_REAL  ,
                              ETAT : element.ETAT == null?'' :element.ETAT  ,
                              STATUT: element.STATUT == null?'' :element.STATUT  ,
                              NATURE: element.NATURE == null?'' :element.NATURE  ,
                              INTERET: element.INTERET == null?'' :element.INTERET  ,
                              NUM_AFFAIRE:element.NUM_AFFAIR == null?'' :element.NUM_AFFAIR  ,
                              RESSOURCE:element.RESSOURCE == null?'' :element.RESSOURCE  ,
                              PRESTATAIRE:element.PRESTATAIRE == null?'' :(temp_presta==null?'' : temp_presta.RES_LIB)  ,
                              NUM_DEV:element.NUM_DEV == null?'' :element.NUM_DEV,
                              QUANTITE:element.QUANTITE == null?'' :element.QUANTITE,
                              MONTANT:element.MONTANT == null?'' :element.MONTANT,
                              DTE_CONF:element.dte_conf == null?'' :element.dte_conf,
                              VILLE:element.VILLE == null?'' :element.VILLE  ,
                              DTE_SIGN:element.DTE_SIGN == null?'' :element.DTE_SIGN  ,
                              ADRESSE_COMPLETE_ACTION:element.ADRESSE_COMPLETE_ACTION == null?'' :element.ADRESSE_COMPLETE_ACTION ,
                              SECTEUR_COMMERCIAL:element.SECTEUR_COMMERCIAL==null?'':element.SECTEUR_COMMERCIAL,
                              nbr_task:element.nbr_task,

                            }
                         
                      })



                      // barre de recherche 
                      resultSearch = resultSearch.filter(data => !this.search ||
                      data.ASSISTANT.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.VENDEUR.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.AUTEUR.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.CDE_CLI.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.ORIGINE.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.PRIORITE.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.NOM_CLI.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.NUM_ACTION.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.OBJET.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.DTE_CREAT.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.DTE_PREV.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.DTE_REAL.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.ETAT.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.STATUT.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.NATURE.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.INTERET.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.NUM_AFFAIRE.toLowerCase().includes(this.search.toLowerCase())||
                      data.QUANTITE.toLowerCase().includes(this.search.toLowerCase())||
                      data.DTE_SIGN.toLowerCase().includes(this.search.toLowerCase())||
                      data.ADRESSE_COMPLETE_ACTION.toLowerCase().includes(this.search.toLowerCase())||
                      data.SECTEUR_COMMERCIAL.toLowerCase().includes(this.search.toLowerCase()) ||
                      data.VILLE.toLowerCase().includes(this.search.toLowerCase())
                      )
                      
                      
                      if(!this.is_history) {
                        let thirtyDate = new Date(new Date().setDate(new Date().getDate() - 30));
                        resultSearch= resultSearch.filter(data => data['ETAT'] != 'Cloturé' || (data['ETAT'] == 'Cloturé' &&  
                          new Date(data['DTE_REAL'].split('/')[2]+'-'+data['DTE_REAL'].split('/')[1]+'-'+data['DTE_REAL'].split('/')[0]) > thirtyDate
                        ));
                      }
                      
                            for( name in this.dialogActionFiltre){
                              var ladate=''
                              if (typeof name == "string"){
                                if (this.dialogActionFiltre[name] != '' && name != 'DTE_PREV' && name != 'DTE_REAL' &&  name != 'TECHNICIEN'){
                                  resultSearch= resultSearch.filter(data =>!this.dialogActionFiltre[name] || data[name].toLowerCase().includes(this.dialogActionFiltre[name].toLowerCase()))
                                }
                                if(name == 'TECHNICIEN' && this.dialogActionFiltre['TECHNICIEN'] != '') {
                                  resultSearch= resultSearch.filter(data =>!this.dialogActionFiltre['TECHNICIEN'] || data['RESSOURCE'].toLowerCase().includes(this.dialogActionFiltre['TECHNICIEN'].toLowerCase()))
                                }
                                if (this.dialogActionFiltre['DTE_REAL'] != '' && typeof this.dialogActionFiltre['DTE_REAL'] == "string"
                                  && (name == 'DTE_REAL')) {
                                  
                                  if(this.radio=='3') ladate='DTE_PREV';
                                  else if(this.radio=='6') ladate='DTE_REAL';
                                  else if(this.radio=='9') ladate='DTE_CREAT';
                                    
                                    resultSearch= resultSearch.filter(data => 
                                     
                                    new Date(

                                      this.dialogActionFiltre['DTE_REAL'].split('-')[2]+'-'+this.dialogActionFiltre['DTE_REAL'].split('-')[1]+'-'+this.dialogActionFiltre['DTE_REAL'].split('-')[0]
                                      ) >= new Date(
                                      data[ladate].split('/')[2]+'-'+data[ladate].split('/')[1]+'-'+data[ladate].split('/')[0]
                                      )
                                  )
                                }
                                if (this.dialogActionFiltre['DTE_PREV'] != '' && typeof this.dialogActionFiltre['DTE_PREV'] == "string" 
                                  && (name == 'DTE_PREV')) {
                                  
                                  if(this.radio=='3') ladate='DTE_PREV';
                                  else if(this.radio=='6') ladate='DTE_REAL';
                                  else if(this.radio=='9') ladate='DTE_CREAT';
                                    resultSearch= resultSearch.filter(data => 
                                    new Date(
                                      this.dialogActionFiltre['DTE_PREV'].split('-')[2]+'-'+this.dialogActionFiltre['DTE_PREV'].split('-')[1]+'-'+this.dialogActionFiltre['DTE_PREV'].split('-')[0]
                                      ) 
                                    <= new Date(
                                      data[ladate].split('/')[2]+'-'+data[ladate].split('/')[1]+'-'+data[ladate].split('/')[0]

                                      )
                                  )
                                }
                              }
                            }
                            this.count_table=resultSearch.length;
                            if(this.table_index == 0)
                            return resultSearch.slice(this.table_index*this.table_size, (this.table_index + 1)*this.table_size) 
                            else
                            return resultSearch.slice((this.table_index-1)*this.table_size, this.table_index*this.table_size) 
                  
                    }

                    
                  
     },
     mounted (){
      let btn_next  = document.getElementsByClassName("btn-next")[0];
      btn_next.style = "margin-top:7px";
      let btn_prev  = document.getElementsByClassName("btn-prev")[0];
      btn_prev.style = "margin-top:7px";
     },
 methods: {
   AfficherCreationTache(){
      this.dialogFormTacheVisible = true;
          
     
   },
   tester123(){
     document.getElementsByClassName('v-modal')[0].remove() ; 
   },
   
  handleSizeChangePagination(val){
        this.table_size=val;
      },
        handleCurrentChangePagination(val){
            this.table_index=val;
        },
      handleLocation(index, row) {
        window.open('https://maps.google.com/?q='+row.ADRESSE_COMPLETE_ACTION.replace(/[ ()]/g,'+'),'_blank');
			},

      handleBtnDetail(row){
          this.$router.push( {path: '/admin/action', query: { num_act: row.NUM_ACTION }} )
      },
      tableCellClassName({row, column, rowIndex, columnIndex}) {
   
        if (row.ETAT === 'En cours' && column.property==='ETAT') {
          return 'en-cours-cell' 
        
        } else if (row.ETAT === 'Cloturé' && column.property==='ETAT') {
          return 'cloture-cell';
        }

          else if (row.ETAT === 'En cours' && column.property==='ETAT' && new Date(row.DTE_PREV.split('/')[2], row.DTE_PREV.split('/')[1],  row.DTE_PREV.split('/')[0]) <new Date()) {
          return 'late-cell';
        }        
        return '';
      
    },
     handle_delete_filtre () {
          this.dialogActionFiltre.VENDEUR = ''
          this.dialogActionFiltre.AUTEUR = ''
          this.dialogActionFiltre.ETAT = ''
          this.dialogActionFiltre.OBJET = ''
          this.dialogActionFiltre.CDE_CLI = ''
          this.dialogActionFiltre.SECTEUR_COMMERCIAL = ''
          this.dialogActionFiltre.DTE_PREV = ''
          this.dialogActionFiltre.DTE_REAL = ''
          this.dialogActionFiltre.NUM_AFFAIRE = ''
          this.dialogActionFiltre.TECHNICIEN = ''
          this.dialogActionFiltre.PRESTATAIRE = ''
      },

      handle_valider_filtre(){
      
		
		},

    handleModifieTache(numACT,rang,DTE_REAL2) {
           // console.log("handleModifieTache")
           var seld=this
 
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': numACT,
                    'rang': rang,
                    'dte_real_tache':DTE_REAL2,
                    'insertH':seld.insertH
                    // 'ind':this.index
                },
                dataType: "html",
                success: function(data) {
                    console.log(' le row pour Date de realisation à jour ');

                }
            });
        },

      newDateRealiz(){
            this.sidebarStore.showSidebar=true
                for (var i = 0; i < this.listeTaches.length; i++) {
                    if ((this.listeTaches[i].DTE_REAL2 ==null) && (this.RANGCourant!=-1)){
                        if(this.listeTaches[i].RANG ==  this.RANGCourant){
                            this.listeTaches[i].DTE_REAL2 = moment(this.dialogTache.date_real, "yyyy-DD-MM").format(
                "DD/MM/YYYY");
                            this.handleModifieTache(this.listeTaches[i].NUM_ACTION,this.listeTaches[i].RANG,this.listeTaches[i].DTE_REAL2) 
                        }
              }
            }
          location.reload()
        }, 

        handleClose() {
            this.dialogTache.intervenant = '';
            this.dialogTache.tache = '';
            this.dialogTache.date_prev = new Date();
            this.dialogTache.date_real = '';
            this.dialogTache.observation = '';
            
        }, 
        
        handleCloseReload() {

            
        }, 

        verifChampsTache() {
            var complet = 0;
            if ($('#dialogIntervenant').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir un intervenant', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            } else if ($('#dialogTache').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir une tâche', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            } else if ($('#dialogDate_prev').val() == '') {
                complet = 1;
                this.$alert('Veuillez saisir une date prévue', 'Erreur', {
                    confirmButtonText: 'OK'
                });
            }
            return complet;
        },


    handletaches(index,row){
    this.tachesVisible=true;
    this.numAct=row.NUM_ACTION
    this.objet=row.OBJET
    var self = this
      $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'list_taches_action': 1,
                    'action': row.NUM_ACTION
                },
                dataType: "json",

            success: function(data){
                 self.listeTaches=data
                 
            }
            });
  this.etat=row.ETAT;
 
 
  },
    

        rowClikedListeTache(row){
       this.texteObs= row.TEXTE
       this.RANGCourant=row.RANG
        },

         

        handleSupprimerTache(rang) {
            var rangTemp=rang
            var self=this
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'deleteTache': 1,
                    'numAct': this.numAct,
                    'rang': rang
                },
                dataType: "html",
                success: function(data) {

                    self.listeTaches= self.listeTaches.filter(data3 => 
                        !data3.RANG.includes(rangTemp))
                  

                 
                    }
                })
            
        },
        handleTextarea(texte){
           var seld=this
                
                var textPrep = encodeURI(this.$refs.commentPrep.value)
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct':this.numAct,
                        'preparation': textPrep,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                });

                var textCompteRend = encodeURI(this.$refs.commentCompteRend.value)
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'compte_rendu': textCompteRend,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                });
         },

            /******************************************************************** */  
        handleTextareaTache(texte, rang) {
            var seld=this

            if (texte == 0) {
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'tache': event.currentTarget.value,
                        'rang': this.RANGCourant,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                });
            } else if (texte == 1) {
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': this.numAct,
                        'observation': event.currentTarget.value,
                        'rang': this.RANGCourant,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                });
            }
        },
   /***************************************************************************** */
		handleEnregistrementTache() {
            var complet = this.verifChampsTache();
            if (complet == 0) {
                var temp = this;

          var date_prev = moment(document.getElementById('dialogDate_prev').value, "dd-MM-yyyy HH:mm").format("YYYY-MM-DDTHH:mm:ss.S");
          var date_real = moment(document.getElementById('dialogDate_real').value, "dd-MM-yyyy HH:mm").format("YYYY-MM-DDTHH:mm:ss.S");
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'insertTache': 1,
                        'numAct': this.numAct,
                        'intervenant': $('#dialogIntervenant').val(),
                        'tache': $('#dialogTache').val(),
                        'date_prev': $('#dialogDate_prev').val(),
                        'date_real': $('#dialogDate_real').val(),
                        'observation': $('#dialogObservation').val()
                    },
                    dataType: "json",
                    success: function(data) {
                        temp.dialogFormTacheVisible = false;
                        temp.listeTaches = data;

                        temp.listetache.push({"TACHE":$('#dialogTache').val()});
                        temp.listetache.sort((a, b) => a.TACHE.localeCompare(b.TACHE));
                        
                        temp.select = '';
                    }
                });
            }
            //location.reload();
        },

    handleRetour(){
            this.dialogFormActionVisible=false;
            this.dialogAction.client='';
            this.dialogAction.objet='';
            this.dialogAction.priorite='';
            this.dialogAction.date='';
            this.dialogAction.date_fin='';
            this. dialogAction.date_creat ='';

    },
    
       
     
      handleblurDtePrev() {
            $('.date_picker_mobile').css('display', 'none');
        },

      handleDtePrev() {
            if (this.dte_prev === null) {
                this.dte_prev = '';
            }
            var date_prev = moment(document.getElementById('detail_dte_prev').value, "DD-MM-yyyy HH:mm").format(
                "YYYY-MM-DD HH:mm:ss");
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_prev': date_prev.replace(" ", "T")
                },
                dataType: "html",
            });
            //La suite permet de passer les heures en francais (sans les AM PM)
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_prev': this.dte_prev
                },
                dataType: "html",
            });
        },

handleSelectChangeTache(champ, rang) {
            var lib_50 = event.currentTarget.textContent;
            var seld=this
            if(champ =='activite'){
                $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': seld.numAct,
                        'activite': seld.activite,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        console.log('update fini');
                    }

                });
            }
            if (champ == 'RESSOURCE') {
                var request = $.ajax({
                    url: BACKEND_URL+"controller/action.php",
                    async: false,
                    type: "POST",
                    data: {
                        'update': 1,
                        'numAct': seld.numAct,
                        'ressource': lib_50,
                        'rang': rang,
                        'insertH':seld.insertH
                    },
                    dataType: "html",
                    success: function(data) {
                        
                    }

                });
            }
        },

        handleDteRange() {

        },
        handleDtePrev_tache(rang, index) {
            var seld=this
            if (this.taches_PRE.taches_PRE_ID[index] === null) {
                this.taches_PRE.taches_PRE_ID[index] = '';
            }
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_prev_tache': this.taches_PRE.taches_PRE_ID[index],
                    'rang': rang,
                    'insertH':seld.insertH
                },
                dataType: "html",
            });
        },

                handleDteReal_tache(rang, index) {
            var seld=this
            if (this.taches_REA.taches_REA_ID[index] === null) {
                this.taches_REA.taches_REA_ID[index] = '';
            }
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_real_tache': this.taches_REA.taches_REA_ID[index],
                    'rang': rang,
                    'insertH':seld.insertH
                },
                dataType: "html",
            });
        },


         handleblurDteReal() {
            $('.date_picker_mobile').css('display', 'none');
        },
        handleDteReal() {
            if (this.dte_real === null) {
                this.dte_real = '';
            }
            var date_real = moment(document.getElementById('detail_dte_real').value, "DD-MM-yyyy HH:mm").format(
                "YYYY-MM-DD HH:mm:ss");
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_real': date_real.replace(" ", "T")
                },
                dataType: "html",
            });
            //La suite permet de passer les heures en francais (sans les AM PM)
            var request = $.ajax({
                url: BACKEND_URL+"controller/action.php",
                async: false,
                type: "POST",
                data: {
                    'update': 1,
                    'numAct': this.numAct,
                    'dte_real': this.dte_real
                },
                dataType: "html",
            });
        }, 
   
    tableRowClassName({row, rowIndex}) {
        // console.log(rowIndex %2)
        if (rowIndex % 2 == 0) {
          return 'pair-row';
        } else if (rowIndex % 2 !== 0) {
          return 'impair-row';
        }
        return '';
      
    },

  kerkessni(){
        var baa3 =window.location.href.substring(0, window.location.href.length - 13);
         document.location.href=baa3+'action';
          location.reload();
        
      },
      handleEnregistrementAction(){
        var complet = this.verifChampsTache();
        var self=this
        if (complet==0) {
          var date_creat = moment(document.getElementById('dialogDate_creat').value, "DD-MM-YYYY").format("YYYY-MM-DDTHH:mm:ss.S");
          var date_prev = moment(document.getElementById('dialogDate_prev').value, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ss.S");
          var date_fin = moment(document.getElementById('dialogDate_fin').value, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ss.S");
          var request = $.ajax({
  					url: BACKEND_URL+"controller/suivi_actions.php",
  					async: false,
  					type: "POST",
            data: {
              'insertAction' : 1,
              'client': this.dialogAction.client,
              'objet':this.dialogAction.objet,
              'commercial':this.dialogAction.commercial,
              'priorite':this.dialogAction.priorite,
              'date_creat':date_creat,
              'date_prev':date_prev,
              'date_fin':date_fin
            },
  					dataType: "json",
            success: function(data){
                 self.$router.push( {path: '/admin/action', query: { num_act: data }} )
          	}	});
        }
      },

      isActionLate(actionDate) {
        const date_jour = moment(new Date(), "DD-MM-YYYY HH:mm").format("MM-DD-YYYY HH:mm");
        const date_action =moment(actionDate, "DD-MM-YYYY HH:mm").format("MM-DD-YYYY HH:mm");   
        return date_jour > date_action;
      }
          
    },
     created() {

        $.ajaxSetup({
            data: {
              'sessionId': this.$store.getters.sessionId,
            },
          });
       var self= this
        var request = $.ajax({
            url: BACKEND_URL+"controller/suivi_actions.php",
            async: false,
            type: "POST",
            data: {
            },
            dataType: "html",
            success: function(data) {
                var dataParsed = JSON.parse(data)
                
                console.log(dataParsed.listetache);
                self.listetache=dataParsed.listetache
                console.log(self.$store.getters.restriction+'  '+self.$store.getters.vendeur);
                switch(true){
                  case (self.$store.getters.restriction == 1 && self.$store.getters.vendeur !== null):
                    self.tableData = dataParsed.listeActions.filter(data =>data.CDE_PROFIL == self.$store.getters.login && data.VENDEUR == self.$store.getters.vendeur);
                    break;

                  case (self.$store.getters.restriction == 1 && self.$store.getters.vendeur == null):
                    self.tableData = dataParsed.listeActions.filter(data => data.CDE_PROFIL == self.$store.getters.login);
                    break;

                  case (self.$store.getters.restriction != 1 && self.$store.getters.vendeur !== null):
                    self.tableData = dataParsed.listeActions.filter(data => data.VENDEUR == self.$store.getters.vendeur);
                    break; 

                  default:
                    self.tableData = dataParsed.listeActions;
                    break;
                  }

                // if (self.$store.getters.restriction==1)
                //   self.tableData=dataParsed.listeActions.filter(data=>data.CDE_PROFIL==self.$store.getters.login)
                // else
                //  self.tableData=dataParsed.listeActions

                //  if (self.$store.getters.vendeur != null)
                //   self.tableData=dataParsed.listeClients.filter(data=>data.VENDEUR2==self.$store.getters.vendeur || data.VENDEUR==self.$store.getters.vendeur )
                //  else
                //   self.tableData=dataParsed.listeClients  

                
            }
        })
       request = $.ajax({
            url: BACKEND_URL+"controller/suivi_actions.php",
            async: false,
            type: "POST",
            data: {
              'Filtres_actions' : 1,
            },
            dataType: "html",
            success: function(data) {
                var dataParsed = JSON.parse(data)  
                self.listeCommercial=dataParsed.listeCommercial
                self.listeSecteur=dataParsed.listeSecteur
                self.optionsNom_Cli=dataParsed.optionsNom_Cli
                self.listeAffaire=dataParsed.listeAffaire
                self.listeTechniciens=dataParsed.listeTechniciens
                self.listePrestataires=dataParsed.listePrestataires
                self.listeEtat=dataParsed.listeEtat
                self.listeObjet=dataParsed.optionsObjet
                self.listeAuteur=dataParsed.listeAuteur
                
                /*
                self.optionsObjet=dataParsed.optionsObjet
                self.optionsPriorite=dataParsed.optionsPriorite
                */
            }
        })

        $.ajax({
            url: BACKEND_URL+"controller/action.php",
            async: false,
            type: "POST",
            data: {
              'get_list_intervenants' : 1,
            },
            dataType: "json",
            success: function(data) {
                self.listeIntervenants=data;
         
                
            }
        })
    }
  }

  
</script>
<style>
legend {
    border: 1px solid black;
    font-size: 20px;
    text-align: left;
    margin-left: 20px;
    background-color: #33434a;
    color: #fff;
    padding: 1px 3px;
}
.el-table__header-wrapper {
  height: 35px;
}
th > .cell {
  margin-top: -10px;
}
.el-table th {
	border-width: 1px;
	border-style: solid;
	border-color: white;
}
/*
fieldset{
    width: 790px;
    border: 1px solid black;
}*/
</style>
